(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/play.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/play.js');
"use strict";



const {
  withRouter
} = ReactRouterDOM;
const {
  connect
} = ReactRedux;
const {
  Trotting
} = svs.components.sport.sportTypes.SportTypes;
const {
  Contextual,
  branding,
  message,
  api
} = svs.components.dialog;
const {
  cdn
} = svs.core.config.data.svsconfig;
const {
  Button,
  ReactIcon
} = svs.ui;
const {
  BetslipWrapper,
  OverviewContainer,
  ContextMenu,
  Actionbar,
  PayWager,
  Coupon
} = svs.challenge;
const {
  useRef,
  useCallback
} = React;
const {
  DrawSelector
} = svs.sport;
const {
  CampaignFlerp
} = svs.components.lbUi.campaignFlerp;
const isMobile = svs.core.detect.formfactor.mobile();
const Play = _ref => {
  let {
    settings,
    updateMultipSwiper,
    selectedDraw,
    selectedCoupon,
    selectAlternative,
    draws,
    history,
    currentDrawNumber,
    selectedEventNumber,
    isNFL,
    clearCoupon
  } = _ref;
  let trottingText = 'Övr - övriga hästar i loppet';
  if (svs.challenge.data.config.specialTrottingEvent && svs.challenge.data.config.specialTrottingEvent.drawNumber === selectedDraw.drawNumber) {
    var _svs$challenge$data$c;
    selectedDraw.sport.type = Trotting;
    trottingText = ((_svs$challenge$data$c = svs.challenge.data.config.specialTrottingEvent) === null || _svs$challenge$data$c === void 0 ? void 0 : _svs$challenge$data$c.drawText) || 'Krysstexten ska vara X = Dött lopp eller ingen av hästarna är prisplacerad (Topp 7)';
  }
  const handleHelpButtonClick = e => {
    if (svs.challenge.data.config.helpTexts) {
      const isTrotting = selectedDraw.sport && selectedDraw.sport.type === Trotting;
      const dialog = new Contextual({
        attachTo: e.currentTarget,
        branding: branding.SPORT,
        message: [{
          text: isTrotting ? svs.challenge.data.config.helpTexts.startpage_mark_trotting.body : svs.challenge.data.config.helpTexts.startpage_mark.body,
          type: message.TEXT
        }],
        title: isTrotting ? svs.challenge.data.config.helpTexts.startpage_mark_trotting.title : svs.challenge.data.config.helpTexts.startpage_mark.title
      });
      api.add(dialog);
    }
  };
  const confirmClearCoupon = React.useCallback(() => {
    const dialog = new svs.components.dialog.Confirm({
      actions: [{
        title: 'Avbryt'
      }, {
        callback: () => {
          clearCoupon(currentDrawNumber);
          dialog.close();
        },
        title: 'Fortsätt'
      }],
      branding: svs.components.dialog.branding.SPORT,
      icon: 'dustbin',
      title: 'Vill du rensa dina tecken?'
    });
    svs.components.dialog.api.add(dialog);
  }, [clearCoupon, currentDrawNumber]);
  const scrollRef = useRef();
  const getScrollContainer = useCallback(() => svs.core.detect.formfactor.mobile() ? scrollRef.current.querySelector('.js-swiper-container') : scrollRef.current, []);
  const isTrotting = selectedDraw && selectedDraw.sport && selectedDraw.sport.type === Trotting;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "modal-sticky",
    id: "modal-sticky"
  }), React.createElement("div", {
    className: "lb-modal-hidden-content"
  }, React.createElement(OverviewContainer, null), React.createElement("div", {
    className: "game-column-content"
  }, React.createElement(DrawSelector, {
    branding: "challenge",
    drawNumber: currentDrawNumber,
    draws: draws,
    onToggle: updateMultipSwiper,
    selectDraw: drawNumber => {
      history.push("/spela/".concat(drawNumber));
    }
  }), svs.core.detect.formfactor.mobile() && React.createElement(CampaignFlerp, {
    branding: "challenge",
    isLightMode: true
  }), React.createElement("div", {
    className: "challenge-coupon-holder",
    id: "coupon-holder",
    ref: scrollRef
  }, React.createElement(ContextMenu, {
    drawNumber: currentDrawNumber
  }), React.createElement("div", {
    className: "trotting-coupon".concat(!isTrotting ? ' hide' : '')
  }, React.createElement("div", {
    className: "trotting-coupon-text"
  }, trottingText)), React.createElement(Actionbar, {
    currentCoupon: selectedCoupon,
    hasActionbar: selectedCoupon.hasActionbar,
    selectedXpert: selectedCoupon.xperten.selectedXpert
  }), React.createElement("div", {
    className: "padding-xs-h padding-xs-v-1 bg-white"
  }, React.createElement("span", {
    className: "f-bold align-middle"
  }, "V\xE4lj minst ett resultat i varje spelobjekt"), React.createElement("button", {
    className: "align-middle icon-button padding-xs-h",
    onClick: handleHelpButtonClick,
    type: "button"
  }, React.createElement(ReactIcon, {
    color: "fc-sport",
    icon: "help",
    size: "300"
  }))), React.createElement(Coupon, {
    coupon: selectedCoupon,
    draw: selectedDraw,
    history: history,
    selectedEventNumber: selectedEventNumber,
    selectItemAction: selectAlternative,
    settings: settings
  }), React.createElement("div", {
    className: "grid-row ".concat(!isNFL ? 'hide' : '')
  }, React.createElement("div", {
    className: "col-xs-4 col-xs-offset-4"
  }, React.createElement("img", {
    alt: "NFL Logotype",
    className: "block padding-v-1",
    src: "".concat(cdn, "/images/challenge/nfl-logotype.png")
  }))), React.createElement("div", {
    className: "padding-1"
  }, React.createElement(Button, {
    className: "qa-clear",
    onClick: confirmClearCoupon,
    size: 100,
    transparent: true
  }, "Rensa")), !isMobile && React.createElement(React.Fragment, null, React.createElement(PayWager, null), React.createElement(BetslipWrapper, {
    getScrollContainer: getScrollContainer
  }))))), isMobile && React.createElement(React.Fragment, null, React.createElement(PayWager, null), React.createElement(BetslipWrapper, {
    getScrollContainer: getScrollContainer
  })));
};
const mapStateToProps = (state, _ref2) => {
  let {
    match
  } = _ref2;
  const paramDrawNumber = Number(match.params.drawNumber);
  const eventNumber = Number(match.params.eventNumber);
  const selectedDraw = state.draws.find(_ref3 => {
    let {
      drawNumber
    } = _ref3;
    return drawNumber === paramDrawNumber;
  });
  let selectedCoupon;
  if (selectedDraw) {
    selectedCoupon = state.coupons.find(_ref4 => {
      let {
        drawNumber
      } = _ref4;
      return drawNumber === paramDrawNumber;
    });
  }
  let isNFL = false;
  for (let i = 0; i < selectedDraw.drawEvents.length; ++i) {
    if (selectedDraw.drawEvents[i].match && selectedDraw.drawEvents[i].match.league && selectedDraw.drawEvents[i].match.league.uniqueLeagueName === 'NFL') {
      isNFL = true;
      break;
    }
  }
  return {
    currentDrawNumber: paramDrawNumber,
    draws: state.draws,
    isNFL,
    selectedCoupon,
    selectedDraw,
    selectedEventNumber: eventNumber,
    settings: state.settings
  };
};
const {
  selectAlternative,
  clearCoupon
} = svs.challenge.actions;
setGlobal('svs.challenge.Play', withRouter(connect(mapStateToProps, {
  clearCoupon,
  selectAlternative
})(Play)));

 })(window);